import { useEffect } from 'react';

/**
 * Custom hook to detect clicks outside of a specified element
 * @param {React.RefObject} ref - Ref to the element to detect outside clicks for
 * @param {Function} callback - Callback function to execute when outside click is detected
 * @param {boolean} isActive - Whether the hook should be active (default: true)
 */
export default function useOutsideClick(ref, callback, isActive = true) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    if (isActive) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isActive, callback, ref]);
}
